export default "/images/vendor/flag-icons/flags/1x1/hm.svg?92fcad4fd3aacc9e28139fff352bbe4c";